import { COMPANY_NEWS } from '../../constants/Tools';
// TODO - Get support from the team to add a web-search tool for use with this action
// COMPANY_NEWS tool is not the correct tool to use but at least generates a valid response given a url
// Git issue: https://git.hubteam.com/HubSpot/copilot-issues/issues/345
/**
 * Converts a legacy Summarize Article action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertSummarizeArticleAction = inAppActionLegacy => {
  return {
    name: COMPANY_NEWS,
    arguments: {
      '@type': 'map',
      value: {
        domain: {
          '@type': 'string',
          value: inAppActionLegacy.url
        },
        // TODO - `paginationId` - handle since V1 does not support that data
        // Legacy action doesn't support paginationId
        paginationId: {
          '@type': 'string',
          value: ''
        }
      }
    }
  };
};